module.exports = __webpack_public_path__ + "img/customer-service.77fdce19.svg";